import axios from 'axios';

const baseUrl = window.location.origin.includes('localhost')
    ?'http://localhost:8000/api/'
    :'https://bitacorapp.com/api/'

const instance = axios.create({
    baseURL: baseUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default instance;



// WEBPACK FOOTER //
// ./src/repositories/axios.js